import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    IconButton,
    Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { openSnackbar } from 'store/slices/snackbar';
import { useDispatch } from 'react-redux';

/**
 * Khối hiển thị mã mẫu Python với nút copy.
 */
const PythonSampleBlock = ({ sampleCode, label = 'Mã mẫu Python' }) => {
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState(false);

    const handleCopy = () => {
        const text = typeof sampleCode === 'string' ? sampleCode : '';
        if (!text) return;
        const copyToClipboard = (t) => {
            if (typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                return navigator.clipboard.writeText(t);
            }
            const ta = document.createElement('textarea');
            ta.value = t;
            ta.setAttribute('readonly', '');
            ta.style.position = 'absolute';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            try {
                document.execCommand('copy');
                return Promise.resolve();
            } catch (e) {
                return Promise.reject(e);
            } finally {
                document.body.removeChild(ta);
            }
        };
        copyToClipboard(text).then(
            () => {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Đã copy mã mẫu',
                        variant: 'alert',
                        alert: { color: 'success' }
                    })
                );
            },
            () => {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Không copy được',
                        variant: 'alert',
                        alert: { color: 'error' }
                    })
                );
            }
        );
    };

    if (!sampleCode || typeof sampleCode !== 'string' || !sampleCode.trim()) return null;

    return (
        <Accordion
            expanded={expanded}
            onChange={(_, v) => setExpanded(v)}
            sx={{ mt: 2, '&:before': { display: 'none' }, boxShadow: 'none', border: '1px solid', borderColor: 'divider' }}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle2" fontWeight={600}>
                    {label}
                </Typography>
                <IconButton
                    component="span"
                    size="small"
                    onClick={(e) => { e.stopPropagation(); handleCopy(); }}
                    sx={{ ml: 1 }}
                    title="Copy"
                >
                    <ContentCopyIcon fontSize="small" />
                </IconButton>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
                <Box
                    component="pre"
                    sx={{
                        p: 1.5,
                        bgcolor: 'grey.100',
                        borderRadius: 1,
                        overflow: 'auto',
                        fontSize: '0.75rem',
                        fontFamily: 'monospace',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        maxHeight: 280
                    }}
                >
                    <code>{sampleCode}</code>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default PythonSampleBlock;
